import React, { useEffect, useState } from "react";
import { IPoliticAdapterResponse } from "../models/get-politic.model";
import { getPolitics } from "../services/api/politic.service";
import { PoliticCard } from "./cards/politicCard";

import ArrowLeft from '../assets/images/arrow-left.png';
import ArrowExit from '../assets/images/arrow-modal-exit.png';
import ArrowRight from '../assets/images/arrow-right.png';
import loadingIcon from "../assets/images/loading.gif";
import { PdfGeneratorService } from "../services/pdf-generator.service";
import { SendPoliticSingleEmail } from "../services/sendEmail";

interface ModalParams {
    onClose: () => void
}

export const ModalPoliticsDowndload = ({ onClose }: ModalParams) => {

    const service = PdfGeneratorService();

    const [screenSize, setScreenSize] = useState<{ width: number, height: number }>({ width: window.innerWidth, height: window.innerHeight })
    const [modalSize, setModalSize] = useState<string>('1')

    const [page, setPage] = useState<number>(0)
    const [total, setTotal] = useState<number>(0)
    const [totalVisited, setTotalVisited] = useState<number>(0)
    const [listPolitics, setListPolitics] = useState<IPoliticAdapterResponse[]>([]);

    const [isLoading, setIsLoading] = useState<boolean>(false);

    const getCalcScale = () => {
        const width = screenSize.width;
        const height = screenSize.height;

        const defaultSize = '1';

        const fractionWidth = width / 650;
        const fractionHeight = (height - 100) / 300;

        const isWidthLonger = (650 * fractionHeight) >= (width - 100);

        if (width <= 600 && width < height) {
            setModalSize(defaultSize);
            return;
        }

        if (isWidthLonger) {
            setModalSize(fractionWidth.toString())
            return
        }

        if (fractionHeight < 1) {
            const waitSize = (300 * 0.9)
            const currentSize = height - 60
            const isLonger = waitSize >= currentSize
            if (isLonger) {
                const difference = waitSize - currentSize
                const heightDifference = (waitSize) - difference;
                const fractionFixed = 0.9 * heightDifference / waitSize;

                setModalSize(fractionFixed.toString())
                return
            }
        } else {
            const calculatedSize = ((height - 100) * 0.9) / 300;
            setModalSize(calculatedSize.toString())
            return
        }
    }

    const getPoliticList = async (page_: number) => {
        await getPolitics({
            page: page_,
            size: 8,
        })
            .then(res => {
                setListPolitics(res?.response.data.politics ?? [])
                setTotal(res?.response.data.total ?? 0)
                setTotalVisited(res?.response.data.totalVisited ?? 0)
            })
    }

    const downloadDocument = (politic: IPoliticAdapterResponse) => {
        const link = document.createElement("a");
        link.href = `/pdfs/${politic.description}.pdf`;
        link.download = `${politic.description}.pdf`;
        link.click();
    }

    const handleSelectPolitic = async (politic: IPoliticAdapterResponse) => {
        setIsLoading(true);

        const data = {
            politic_name: politic.name
        }

        downloadDocument(politic);
        await service.generatePoliticCertificate(data);

        await SendPoliticSingleEmail(politic);

        setIsLoading(false);
    }

    const handleSetPage = async (positive: boolean) => {
        const _page = page + (positive ? 1 : -1);
        setPage(_page)
        await getPoliticList(_page)
    }

    const isPortraitAndMiniumSize = () => {
        return screenSize.width <= 600 && screenSize.width < screenSize.height;
    }


    useEffect(() => {
        const handleResize = () => {
            setScreenSize({ width: window.innerWidth, height: window.innerHeight });
        };

        window.addEventListener('resize', handleResize);

        return () => {
            window.removeEventListener('resize', handleResize);
        }
    }, []);

    useEffect(() => {
        getCalcScale()
    }, [screenSize])

    useEffect(() => {
        getCalcScale()
        getPoliticList(page)
    }, [])

    return (
        <>
            {
                isLoading && (
                    <div className="loading_all_page">
                        <img src={loadingIcon} alt="loading" width="120" height="120" />
                    </div>
                )
            }
            <div className="modal">
                <div
                    className={`modal-body modal-politic-body ${isPortraitAndMiniumSize() ? 'ordered' : ''}`}
                    style={{ scale: modalSize }}>
                    <div className="politics-board">
                        {
                            page > 0 &&
                            <button key="arrow-left" className="left-button" onClick={() => handleSetPage(false)}>
                                <img key="arrow-left" src={ArrowLeft} alt="arrow-left" />
                            </button>
                        }
                        {
                            ((page + 1) * 8) < total &&
                            <button key="arrow-right" className="right-button" onClick={() => handleSetPage(true)}>
                                <img key="arrow-right" src={ArrowRight} alt="arrow-right" />
                            </button>
                        }
                        {
                            totalVisited === total &&
                            <button key="arrow-exit" className="exit-button" onClick={onClose}>
                                <img key="arrow-exit-image" src={ArrowExit} alt="arrow-exit" />
                            </button>
                        }
                        <div className="politics-board-container">
                            {
                                listPolitics.map(item => (
                                    <PoliticCard politic={item} onSelect={handleSelectPolitic} isDownload />
                                ))
                            }
                        </div>
                    </div>
                </div>
            </div>
        </>
    )
}